import { Component, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';

const { ccclass } = _decorator;

@ccclass('FreePlayButton')
export default class FreePlayButton extends Component {
    protected onLoad() {
        if (!Lobby.config.enableFreePlay) {
            this.node.active = false;
        }
    }
}
